import axios, { AxiosInstance } from 'axios';
import qs from 'qs';

export class ApiService {
    private server: string;
    private port: string;
    private access_token: string | undefined;
    private xApiKey: string | undefined;
    private api: AxiosInstance;

    constructor(server: string, port: string, access_token: string | undefined, xApiKey?: string) {
        this.server = server;
        this.port = port;
        this.xApiKey = xApiKey;
        this.access_token = access_token;
        this.api = this.instantiateApi();
    }

    private getHeadersDefault(access_token?: string | undefined, xApiKey?: string): any {
        const headersDefault: any = {
            'Content-Type': 'application/json',
        };
        if (!!xApiKey) {
            headersDefault['x-api-key'] = xApiKey;
        }
        if (!!access_token) {
            headersDefault['Authorization'] = `bearer ${access_token}`;
        }
        return headersDefault;
    }

    private instantiateApi(): AxiosInstance {
        let baseUrlTemp = this.server.endsWith('/api/') ? this.server.slice(0, -4) : this.server; // technical debt. Change all employee api baseUrl and packs api baseUrl to the same pattern
        if (baseUrlTemp.endsWith('/')) {
            baseUrlTemp = baseUrlTemp.slice(0, -1);
        }

        const api = axios.create({
            baseURL: !!this.port ? `${baseUrlTemp}:${this.port}/api/v1` : `${baseUrlTemp}/api`,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
            headers: this.getHeadersDefault(this.access_token, this.xApiKey),
        });

        return api;
    }

    async get<T = any>(url: string, parameters?: any): Promise<T> {
        const response = await this.api.get<T>(url, {
            params: parameters,
        });
        return response.data;
    }

    async post<T = any>(url: string, body: any): Promise<T> {
        const response = await this.api.post<T>(url, body);
        return response.data;
    }

    async put<T = any>(url: string, body: any): Promise<T> {
        const response = await this.api.put<T>(url, body);
        return response.data;
    }

    async patch<T = any>(url: string, body: T): Promise<T> {
        const response = await this.api.patch<T>(url, body);
        return response.data;
    }

    async delete<T = any>(url: string, parameters?: any): Promise<T> {
        const response = await this.api.delete<T>(url, {
            params: parameters,
        });
        return response.data;
    }
}
